// #region Dados mock
let _data = [
	{ id: 201, nome: 'Corte Feminino', categoria: 'Cabelo', descricao: 'Corte de cabelo feminino tradicional', preco_padrao: 35, perc_comissao_padrao: 30 },
	{ id: 202, nome: 'Escova Progressiva', categoria: 'Cabelo', descricao: 'Tratamento de alisamento capilar', preco_padrao: 150, perc_comissao_padrao: 25 },
	{ id: 203, nome: 'Manicure', categoria: 'Unhas', descricao: 'Cuidados com as unhas das mãos', preco_padrao: 25, perc_comissao_padrao: 40 },
	{ id: 204, nome: 'Pedicure', categoria: 'Unhas', descricao: 'Cuidados com as unhas dos pés', preco_padrao: 30, perc_comissao_padrao: 40 },
	{ id: 205, nome: 'Coloração', categoria: 'Cabelo', descricao: 'Pintura e coloração capilar', preco_padrao: 80, perc_comissao_padrao: 20 },
];
// #endregion

// #region Util
const delay = (ms = 240) => new Promise(r => setTimeout(r, ms));
// #endregion

// #region Métodos
export async function listAll() { await delay(); return _data.map(s => ({ ...s })); }
export async function getById(id) { await delay(); const f = _data.find(s => s.id === id); return f ? { ...f } : null; }
export async function create(payload) { await delay(); const id = Date.now(); const novo = { id, ...payload }; _data = [novo, ..._data]; return { ...novo }; }
export async function update(id, patch) { await delay(); let upd = null; _data = _data.map(s => { if (s.id === id) { upd = { ...s, ...patch }; return upd; } return s; }); return upd ? { ...upd } : null; }
export async function remove(id) { await delay(); _data = _data.filter(s => s.id !== id); return true; }
// #endregion

// #region Export default
const servicosApi = { listAll, getById, create, update, remove };
export default servicosApi;
// #endregion

